var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 72/enter 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.712 8.70156C11.6285 8.70156 11.5868 8.70156 11.5451 8.70156C9.4891 8.70156 7.43723 8.70156 5.3812 8.70156C4.41365 8.70156 3.62543 8.09609 3.4044 7.18162C3.3627 7.00207 3.35019 6.80999 3.34601 6.62626C3.34184 5.78278 3.34601 4.93931 3.34184 4.09583C3.34184 3.66156 3.05408 3.36926 2.64955 3.37762C2.31174 3.38597 2.01564 3.64903 2.01147 3.98726C2.0073 5.03534 1.97393 6.08343 2.04483 7.12734C2.14075 8.522 3.31682 9.74129 4.70141 9.9793C4.93496 10.0211 5.17685 10.0419 5.41456 10.0419C7.4414 10.0461 9.47242 10.0461 11.4993 10.0461C11.5576 10.0461 11.6119 10.0461 11.7078 10.0461C11.6494 10.1046 11.616 10.1463 11.5785 10.1839C11.1197 10.6432 10.6568 11.1025 10.2022 11.566C9.83108 11.946 9.98538 12.5515 10.4858 12.6851C10.7486 12.7561 10.9738 12.6768 11.1656 12.4847C11.9664 11.6788 12.7671 10.8771 13.572 10.0753C13.6512 9.99601 13.7305 9.92502 13.8055 9.84568C14.0599 9.58262 14.0683 9.17758 13.8097 8.91869C12.9214 8.0251 12.0289 7.13569 11.1364 6.24628C10.8612 5.97486 10.4608 5.97904 10.1981 6.23375C9.93117 6.49682 9.92283 6.90603 10.1981 7.1858C10.6485 7.6493 11.1072 8.10026 11.566 8.55958C11.6119 8.59299 11.6452 8.63475 11.712 8.70156Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.795ed9d4c4847c93a6fa54490af089d4.svg";
export { ForwardRef as ReactComponent };